import Login from "@/pages/Auth/Login.vue";
import guest from "../middleware/guestMiddleware.js";

export default {
  path: "/login",
  name: "Login",
  component: Login,
  meta: { middleware: [guest] }
};
